export default __webpack_public_path__ + "static/media/m_welcome_bg_bubble.eb4d2f4c.png";